import { useDispatch, useSelector } from "react-redux";
import { useToast } from "../../../../../helpers/commonFunction";
import {
    copyCanvasStyles,
    copyStyles,
} from "../../../../../stateManager/store/formCreation_v2/actions";

type Props = {
    componentIdsToUpdate?: string[];
    deviceType: string;
    changeTo: string;
    syncTo: string;
};

type DeviceNames = {
  [key: string]: string;
};

const useSyncStyles = () => {
    const { SuccessToast } = useToast();
    const dispatch = useDispatch();
    const { isCoreV3, components } = useSelector((state: any) => state.formJson);

    const syncStyles = (props: Props) => {
        let { componentIdsToUpdate, deviceType, changeTo, syncTo } = props;
        const deviceNames:  DeviceNames  = { Sm: "mobile", Md: "tab", Lg: "desktop" };
        const sourceDevice = deviceNames[deviceType] || "desktop";
        let showMsg = `Styles synced from ${sourceDevice} and applied to ${
            deviceNames[changeTo] || "desktop"
        }`;
        let updatedComponetIdsToUpdate = componentIdsToUpdate;
        //Filter the componentsIdsToUpdate without the formwizard id, restrict the sync style for formwizard.
        if (isCoreV3) {
            updatedComponetIdsToUpdate = componentIdsToUpdate?.filter((id: any) => components[id] && components[id].type !== 'FormWizard').map((id: any) => components[id].id);
        }
        if (changeTo === "All") {
            ["Sm", "Md", "Lg"].forEach((targetDeviceType) => {
                if (targetDeviceType !== deviceType) {
                    if (syncTo == "COMPONENT") {
                        dispatch(
                            copyStyles(
                                updatedComponetIdsToUpdate,
                                deviceType,
                                targetDeviceType
                            )
                        );
                    }
                    if (syncTo == "CANVAS") {
                        dispatch(
                            copyCanvasStyles(deviceType, targetDeviceType)
                        );
                    }
                    if (syncTo == "ALL") {
                        dispatch(
                            copyCanvasStyles(deviceType, targetDeviceType)
                        );
                        dispatch(
                            copyStyles(
                                updatedComponetIdsToUpdate,
                                deviceType,
                                targetDeviceType
                            )
                        );
                    }
                }
            });
            showMsg = `Styles synced from ${sourceDevice} and applied to ${[
                "Sm",
                "Md",
                "Lg",
            ]
                .filter((d) => d !== deviceType)
                .map((d) => deviceNames[d])
                .join(" and ")}`;
        } else {
            if (syncTo == "COMPONENT") {
                dispatch(
                    copyStyles(updatedComponetIdsToUpdate, deviceType, changeTo)
                );
            }
            if (syncTo == "CANVAS") {
                dispatch(copyCanvasStyles(deviceType, changeTo));
            }
            if (syncTo == "ALL") {
                dispatch(copyCanvasStyles(deviceType, changeTo));
                dispatch(
                    copyStyles(updatedComponetIdsToUpdate, deviceType, changeTo)
                );
            }
        }
        SuccessToast(showMsg);
    };

    return { syncStyles };
};

export default useSyncStyles;